import apiFetch from '../../apiFetch'

export default function (dossierId, isHistorical, token) {
  const body = {
    DossierId: dossierId,
    IsHistorical: isHistorical
  }
  return apiFetch({ endPoint: 'Dossier/RegisterAccess', method: 'POST', body: body, token: token })
}
